import { useLocation } from 'react-router-dom'

function extractNavPath(pathname: string): string {
    const path = pathname.split('/')

    if (path.length === 0) {
        return ''
    }
    if (path.length === 1) {
        return '/'
    }

    return path.slice(0).join('/')
}

export default function useActiveRoutePath() {
    const location = useLocation()
    return extractNavPath(location.pathname)
}
